import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useCodelist } from "../../../hooks/useCodelist";

const useESignField = ({ codes }: any) => {
  const [showPassword, setShowPassword] = useState(false);
  const { getCodelistData, codelistData } = useCodelist();

  useEffect(() => {
    getCodelistData({ data: { code_list_codes: [codes] } });
  }, []);

  const eSignFields = [
    {
      name: "sign_reason",
      label: "Select Reason",
      size: 12,
      inputType: "autocomplete",
      options: codelistData?.find((ele: any) => ele[codes])?.[codes] ?? [],
      required: true,
    },
    {
      name: "email",
      label: "Email Address",
      size: 12,
      maxlength: 254,
      required: true,
      disabled: true,
    },
    {
      name: "password",
      label: "Password",
      size: 12,
      maxlength: 16,
      required: true,
      type: showPassword ? "text" : "password",
      autocomplete: "off",
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => {
                setShowPassword((show) => !show);
              }}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      },
    },
  ];

  return { eSignFields, codelistData };
};

export default useESignField;
